import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const env = (typeof import.meta !== 'undefined' && (import.meta as any)?.env) || (typeof process !== 'undefined' && process.env) || {};
const GA_ID = env.VITE_GA_ID;

/**
 * Initialize Google Analytics 4
 */
export const initGA = () => {
  if (GA_ID) {
    ReactGA.initialize(GA_ID);
    console.log('[Analytics] GA4 Initialized with ID:', GA_ID);
  } else {
    console.debug('[Analytics] VITE_GA_ID is missing. Tracking disabled.');
  }
};

/**
 * Track Custom Events
 */
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  params?: Record<string, any>
) => {
  if (!GA_ID) return;

  ReactGA.event({
    category,
    action,
    label,
    value,
    ...params
  });
  
  console.log('[Analytics] Event tracked:', action, params);
};

/**
 * Tracking Hook Component
 * Renders nothing, but listens to route changes
 */
export const RouteTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_ID) return;

    const path = location.pathname + location.search;
    ReactGA.send({ hitType: "pageview", page: path });
    console.log('[Analytics] Pageview tracked:', path);
  }, [location]);

  return null;
};
